import { QueryClient } from "@tanstack/react-query";

/**
 * customer 全体で使う React Query クライアント。
 *
 * mock API (MSW) は失敗しない前提のため retry は無効化する。ops と異なり
 * customer にはトースト UI が無いため、エラー表示は各 hook の呼び出し側
 * (isError / error) に委ねる。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 30,
    },
    mutations: {
      retry: false,
    },
  },
});
